export const checkEven = (number) => {
  //check if the number is even
  let isEven = false;
  if (number % 2 === 0) {
    isEven = true;
  }
  return isEven;
};
